var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"button",on:{"mouseover":_vm.handleMouseOver,"mousemove":_vm.handleMouseMove,"mouseleave":_vm.handleMouseLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }